module.exports = __webpack_public_path__ + "img/MPTechModel.5c24d8d1.png";